import React, { useEffect } from "react";

import { AnimatePresence } from "framer-motion";
import loadable from "@loadable/component";
import useChat from "../../hooks/useChat";
import { IChatContextV2 } from "../../types/ChatInterfaces";
import { postMessageToParent } from "../../utils";
import { IFRAME_ANIMATION_CLOSE_DELAY } from "../../constants";

const checkBlacklistedRoutes = (
  blacklistedRoutes: (string | RegExp)[],
  url: string
) => {
  if (!blacklistedRoutes) return false;
  if (!Array.isArray(blacklistedRoutes)) return false;
  if (blacklistedRoutes.length === 0) return false;
  return blacklistedRoutes?.some((pattern) => {
    const parsedUrl = new URL(url, window.location.origin);

    // Handle RegExp objects
    if (pattern instanceof RegExp) {
      return pattern.test(parsedUrl.pathname);
    }

    // Handle string representations of regex patterns
    if (typeof pattern === "string") {
      // Check if the string looks like a regex pattern (starts with '/ or / and ends with /' or /flags)
      const regexMatch = pattern.match(/^'?\/(.+)\/([gimuy]*)'?$/);
      if (regexMatch) {
        try {
          const [, regexPattern, flags] = regexMatch;
          // Unescape the pattern (convert \\ back to \)
          const unescapedPattern = regexPattern.replace(/\\\\/g, "\\");
          const regex = new RegExp(unescapedPattern, flags);
          return regex.test(parsedUrl.pathname);
        } catch (error) {
          console.warn("Invalid regex pattern:", pattern, error);
          return false;
        }
      }

      // Fallback to string includes for non-regex strings
      return url.includes(pattern);
    }

    return false;
  });
};
const ChatApp = loadable(() => import("../ChatApplication"));
const WidgetWrp = loadable(() => import("../WidgetWrp"));

const getBotView = (type: string) => {
  switch (type) {
    case "side":
      setTimeout(() => {
        WidgetWrp.preload();
      }, 100);
      return <ChatApp key="chatApp" />;
    case "widget":
      setTimeout(() => {
        ChatApp.preload();
      }, 100);
      return <WidgetWrp key="widget" />;
    case "hidden":
      return null;
    default:
      return null;
  }
};

const ChatWidgetView = () => {
  const { activeView, initializeData } = useChat() as IChatContextV2;
  const { blacklistedRoutes, parentUrl } = initializeData || {};
  const isBlacklistedRoute = checkBlacklistedRoutes(
    blacklistedRoutes,
    parentUrl
  );

  useEffect(() => {
    if (isBlacklistedRoute) {
      const timeoutId = setTimeout(() => {
        postMessageToParent("UI.SET-CLASS", [
          "joveo-widget-web",
          `joveo-widget-hidden`,
        ]);
      }, IFRAME_ANIMATION_CLOSE_DELAY);
      return () => clearTimeout(timeoutId);
    }
  }, [isBlacklistedRoute]);
  if (isBlacklistedRoute) {
    console.log("Bot not allowed at current route");
    return null;
  }
  return (
    <AnimatePresence mode="wait">{getBotView(activeView)}</AnimatePresence>
  );
};

export default ChatWidgetView;
